document.addEventListener('DOMContentLoaded', () => {
  const sh = new ShopifyHelpers('descorcha-cl');
  let cartCount = document.querySelector('cart-count');

  async function getCart() {
    await sh.getCart((cart) => {
      updateCartCount(cart);
      return cart;
    });
  }

  function updateCartCount(cart) {
    const { item_count } = cart;
    if (item_count > 0) {
      cartCount.textContent = item_count;
      cartCount.removeAttribute('hidden');

      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          detail: {
            open: false,
          },
        })
      );
      setTimeout(() => {
        const closeDraweBtn = document.querySelector('button.drawer__close-btn[aria-controls="CartDrawer"]');
        closeDraweBtn.addEventListener('click', () => {document.querySelector('.fixed-overlay[aria-controls="CartDrawer"]').click()});
      }, 1500);
    } else {
      cartCount.setAttribute('hidden', '');
      cartCount.textContent = 0;
    }
  }

  function syncCartDrawer() {
    // console.log('syncCartDrawer');
    const removeBtn = document.querySelectorAll(
      'cart-drawer [is="cart-remove-item"]'
    );

    const addBtn = document.querySelectorAll(
      'cart-drawer [name="plus"]'
    );
    const decreaseBtn = document.querySelectorAll(
      'cart-drawer [name="minus"]'
    );

    removeBtn.forEach((btn) => {
      btn.addEventListener('click', () => {
        blockForms();
        const id = Number(btn.dataset.id);
        document
          .querySelectorAll(`.lc-quantity-value[data-variant="${id}"]`)
          .forEach((el) => {
            el.textContent = 1;
          });
        document
          .querySelectorAll(`.lc-single-add-to-cart[data-variant="${id}"]`)
          .forEach((btn) => {
            btn.classList.remove('hidden');
          });
        document
          .querySelectorAll(`.lc-quantity-selectors[data-variant="${id}"]`)
          .forEach((btn) => {
            btn.classList.add('hidden');
          });
        document
          .querySelectorAll(
            `.lc-decrease-from-cart-btn[data-variant="${id}"]`
          )
          .forEach((btn) => {
            btn.classList.add('hidden');
          });
      });
    });

    addBtn.forEach((btn) => {
      btn.addEventListener('click', () => {
        blockForms();
        const id = btn.previousElementSibling.dataset.quantityVariantId;
        const value = document.querySelector(`.quantity__input[data-quantity-variant-id="${id}"]`).value;
        document.querySelectorAll(`.lc-quantity-value[data-variant="${id}"]`)
          .forEach((el) => {
            el.textContent = value;
          });
      });
    });

    decreaseBtn.forEach((btn) => {
      btn.addEventListener('click', () => {
        blockForms();
        const id = btn.nextElementSibling.dataset.quantityVariantId;
        const value = Number(document.querySelector(`.quantity__input[data-quantity-variant-id="${id}"]`).value) || 0;
        document.querySelectorAll(`.lc-quantity-value[data-variant="${id}"]`)
          .forEach((el) => {
            el.textContent = value;
          });
        if (!value) {
          document
            .querySelectorAll(`.lc-quantity-value[data-variant="${id}"]`)
            .forEach((el) => {
              el.textContent = 1;
            });
          document
            .querySelectorAll(`.lc-single-add-to-cart[data-variant="${id}"]`)
            .forEach((btn) => {
              btn.classList.remove('hidden');
            });
          document
            .querySelectorAll(`.lc-quantity-selectors[data-variant="${id}"]`)
            .forEach((btn) => {
              btn.classList.add('hidden');
            });
          document
            .querySelectorAll(
              `.lc-decrease-from-cart-btn[data-variant="${id}"]`
            )
            .forEach((btn) => {
              btn.classList.add('hidden');
            });
        }
      });
    });
  }

  function blockForms() {
    document.querySelectorAll('quantity-input').forEach((el) => {
      el.classList.add('lc-block');
    });
    document.querySelectorAll('.lc-form-container').forEach((el) => {
      el.classList.add('lc-block');
    });
    setTimeout(() => {
      document.querySelectorAll('.lc-form-container').forEach((el) => {
        el.classList.remove('lc-block');
        document.querySelectorAll('quantity-input').forEach((el) => {
          el.classList.remove('lc-block');
        });
      });
    }, 1500);
  }

  class AddToCartBtn {
    constructor(element) {
      this.btn = element;
      this.btn.addEventListener('click', this.onClick.bind(this));
      this.id = Number(this.btn.dataset.variant);
      this.action = this.btn.dataset.action;
    }

    async onClick() {
      blockForms();
      await sh.addToCart(this.id, 1, null, async () => await getCart());
      if (this.action === 'add') {
        document
          .querySelectorAll(`.lc-single-add-to-cart[data-variant="${this.id}"]`)
          .forEach((btn) => {
            btn.classList.add('hidden');
          });
        document
          .querySelectorAll(`.lc-quantity-selectors[data-variant="${this.id}"]`)
          .forEach((btn) => {
            btn.classList.remove('hidden');
          });
        document
          .querySelectorAll(
            `.lc-remove-from-cart-btn[data-variant="${this.id}"]`
          )
          .forEach((btn) => {
            btn.classList.remove('hidden');
          });
        document
          .querySelectorAll(
            `.lc-decrease-from-cart-btn[data-variant="${this.id}"]`
          )
          .forEach((btn) => {
            btn.classList.add('hidden');
          });
      } else if (this.action === 'plus') {
        document
          .querySelectorAll(`.lc-quantity-value[data-variant="${this.id}"]`)
          .forEach((el) => {
            el.textContent = Number(el.textContent) + 1;
          });
        document
          .querySelectorAll(
            `.lc-remove-from-cart-btn[data-variant="${this.id}"]`
          )
          .forEach((btn) => {
            btn.classList.add('hidden');
          });
        document
          .querySelectorAll(
            `.lc-decrease-from-cart-btn[data-variant="${this.id}"]`
          )
          .forEach((btn) => {
            btn.classList.remove('hidden');
          });
      }
    }
  }

  class RemoveFromCartBtn {
    constructor(element) {
      this.btn = element;
      this.id = Number(this.btn.dataset.variant);
      this.btn.addEventListener('click', this.onClick.bind(this));
    }

    async onClick() {
      blockForms();
      await sh.removeFromCart(this.id, async () => await getCart());
      document
        .querySelectorAll(`.lc-quantity-value[data-variant="${this.id}"]`)
        .forEach((el) => {
          el.textContent = 1;
        });
      document
        .querySelectorAll(`.lc-single-add-to-cart[data-variant="${this.id}"]`)
        .forEach((btn) => {
          btn.classList.remove('hidden');
        });
      document
        .querySelectorAll(`.lc-quantity-selectors[data-variant="${this.id}"]`)
        .forEach((btn) => {
          btn.classList.add('hidden');
        });
      document
        .querySelectorAll(
          `.lc-decrease-from-cart-btn[data-variant="${this.id}"]`
        )
        .forEach((btn) => {
          btn.classList.add('hidden');
        });
    }
  }

  class DecreaseFromCartBtn {
    constructor(element) {
      this.btn = element;
      this.id = Number(this.btn.dataset.variant);
      this.btn.addEventListener('click', this.onClick.bind(this));
    }

    async onClick() {
      blockForms();
      await sh.substractFromCart(this.id, 1, async () => await getCart());
      let quantity = Number(
        document.querySelector(`.lc-quantity-value[data-variant="${this.id}"]`)
          .textContent
      );
      quantity = quantity - 1;
      if (quantity <= 1) {
        document
          .querySelectorAll(`.lc-quantity-value[data-variant="${this.id}"]`)
          .forEach((el) => {
            el.textContent = 1;
          });
        document
          .querySelectorAll(
            `.lc-remove-from-cart-btn[data-variant="${this.id}"]`
          )
          .forEach((btn) => {
            btn.classList.remove('hidden');
          });
        document
          .querySelectorAll(
            `.lc-decrease-from-cart-btn[data-variant="${this.id}"]`
          )
          .forEach((btn) => {
            btn.classList.add('hidden');
          });
      } else {
        document
          .querySelectorAll(`.lc-quantity-value[data-variant="${this.id}"]`)
          .forEach((el) => {
            el.textContent = quantity;
          });
      }
    }
  }

  // Inicializar todos los formularios en la página
  const addToCartBtns = document.querySelectorAll('.lc-add-to-cart-btn');
  if (addToCartBtns.length > 0) {
    addToCartBtns.forEach((btn) => {
      new AddToCartBtn(btn);
    });
  }

  const removeFromCartBtns = document.querySelectorAll(
    '.lc-remove-from-cart-btn'
  );
  if (removeFromCartBtns.length > 0) {
    removeFromCartBtns.forEach((btn) => {
      new RemoveFromCartBtn(btn);
    });
  }

  const decreaseFromCartBtns = document.querySelectorAll(
    '.lc-decrease-from-cart-btn'
  );
  if (decreaseFromCartBtns.length > 0) {
    decreaseFromCartBtns.forEach((btn) => {
      new DecreaseFromCartBtn(btn);
    });
  }

  syncCartDrawer();
  document.addEventListener('cart:refresh', () => {
    // console.log('cart:refresh');
    setTimeout(() => {
      syncCartDrawer();      
    }, 500);
  });
  document.addEventListener('cart:updated', () => {
    // console.log('cart:updated');
    syncCartDrawer();
  });
});
